/**
 * algorithm-step.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { StepPresentationHints } from "../../common/data/presentation-hints";
import { TypedDataHolder } from "../../common/data/typed-data";

export interface AlgorithmStepData
{
  id : number;
  name : string;
  displayName : string;
  classifications : string[];
  hints? : StepPresentationHints;
  presentation : string;
}

/**
 * An `AlgorithmStep` models an executable Hammurabi algorithm step. It
 * comprises data required for machine (`id`) or human (`name`) corr\elation
 * between client and server.
 */
export class AlgorithmStep
{
  /**
   * The numeric identifier that represents this algorithm step to the server.
   * This value is allocated by the server, and must be presented to the server
   * when referencing this algorithm step.
   */
  public id : number;

  /**
   * The internal name of the algorithm step. This name represents the
   * algorithm step in persistent data, and is also used for linkage. It is
   * provided to the client only to facilitate debugging; it is not used to
   * identify the algorithm step in server-client communication.
   */
  public name : string;

  public displayName : string;

  /**
   * The classifications of the algorithm step.
   */
  public classifications : string[];

  public hints : StepPresentationHints;

  /**
   * The HTML5 presentation text for this step. This does not include any
   * <input> elements required make this step interactive.
   */
  public presentation : string;

  public isActive? : boolean;

  /**
   * Construct a new {@link AlgorithmStep}.
   *
   * @param data
   *        An object constructed from JSON.
   */
  constructor (data : AlgorithmStepData)
  {
    this.id = data.id;
    this.name = data.name;
    this.displayName = data.displayName;
    this.classifications = data.classifications;
    this.hints = data.hints;
    this.presentation = data.presentation;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/structure/algorithm-step.ts